/**
 * Custom hook to fetch the default CTA button configuration from the backend
 */

import { trpc } from "@/lib/trpc";

export interface CtaButtonConfig {
  text: string;
  variant: string;
}

export function useDefaultCta() {
  // DISABLED: Database queries - using static config only
  // const { data: defaultCta, isLoading, error } = trpc.ctaButtons.getDefault.useQuery();
  const defaultCta: { text: string; variant: string } | null = null;
  const isLoading = false;
  const error = null;

  // Return default fallback if no CTA is configured
  const ctaConfig: CtaButtonConfig = {
    text: defaultCta?.text || "Order Now",
    variant: defaultCta?.variant || "primary",
  };

  return {
    cta: ctaConfig,
    isLoading,
    error,
    hasCustomCta: !!defaultCta,
  };
}
